var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultSection',{staticClass:"press-section",attrs:{"resource":_vm.resource,"id":_vm.resource.slug}},[_c('BaseBox',{staticClass:"experience-section__box py-0"},[_c('BContainer',[_c('NewsCarousel',{attrs:{"items":_vm.news}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }